var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _isSuccess;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { jsonPost } from '@square/dashboard-utilities/utils/xhr';
import { readOnly } from '@ember/object/computed';
import DeviceProfileError, { DeviceProfileMessage } from '@square/dashboard-data/models/device-profiles-v2/device-profile-error';
import { isPresent } from '@ember/utils';
import { camelize, underscore } from '@square/dashboard-utilities/utils/keys';
import { DeviceProfileType } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/shared/device_profile_type';
import { FetchDeviceProfileV2Request, FetchDeviceProfileV2Response } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/message/fetch_device_profile';
import { SearchDeviceProfilesV2Request, SearchDeviceProfilesV2Response, SearchDeviceProfilesV2Query, SearchDeviceProfilesV2Filter } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/message/search_device_profiles';
import { ListDeviceProfileV2TemplateTypesRequest, ListDeviceProfileV2TemplateTypesResponse } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/message/list_template_types';
import { GetDevicesLinkedToProfileV2Request, GetDevicesLinkedToProfileV2Response } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/message/get_devices_linked_to_profile';
import { GetDefaultDeviceProfileV2Request, GetDefaultDeviceProfileV2Response } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/message/get_default_device_profile';
import { captureException } from '@sentry/browser';
import { Pagination } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/message/pagination';
import { Status } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/message/status';
import { CreateDeviceProfileV2Request, CreateDeviceProfileV2Response } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/message/create_device_profile';
import { CreateDefaultDeviceProfileV2Request, CreateDefaultDeviceProfileV2Response } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/message/create_default_device_profile';
import { DuplicateDeviceProfileV2Request, DuplicateDeviceProfileV2Response } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/message/duplicate_device_profile';
import { UpdateDeviceProfileV2Request, UpdateDeviceProfileV2Response } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/message/update_device_profile';
import { DeleteDeviceProfileV2Request, DeleteDeviceProfileV2Response } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/message/delete_device_profile';
import { BatchDeactivateDeviceUsageBillingRequest, BatchDeactivateDeviceUsageBillingResponse } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/message/batch_deactivate_device_usage_billing';
import DeviceProfileV2Model from '@square/dashboard-data/models/device-profiles-v2/device-profile-v2';
const DEVICE_PROFILE_BASE_URL = '/2.0/device_profiles';
const DEVICE_PROFILE_FETCH_URL = `${DEVICE_PROFILE_BASE_URL}/fetch`;
const DEVICE_PROFILE_CREATE_URL = `${DEVICE_PROFILE_BASE_URL}/create`;
const DEVICE_PROFILE_CREATE_DEFAULT_URL = `${DEVICE_PROFILE_BASE_URL}/create_default`;
const DEVICE_PROFILE_UPDATE_URL = `${DEVICE_PROFILE_BASE_URL}/update`;
const DEVICE_PROFILE_DELETE_URL = `${DEVICE_PROFILE_BASE_URL}/delete`;
const DEVICE_PROFILE_DUPLICATE_URL = `${DEVICE_PROFILE_BASE_URL}/duplicate`;
const DEVICE_PROFILE_SEARCH_URL = `${DEVICE_PROFILE_BASE_URL}/search`;
const DEVICE_PROFILE_TEMPLATES_URL = `${DEVICE_PROFILE_BASE_URL}/list_template_types`;
const DEVICE_PROFILE_GET_DEVICES_LINKED_TO_PROFILE = `${DEVICE_PROFILE_BASE_URL}/get_profile_devices`;
const DEVICE_PROFILE_GET_DEFAULT_PROFILE = `${DEVICE_PROFILE_BASE_URL}/get_default`;
const DEVICE_PROFILE_BATCH_DEACTIVATE_DEVICE_USAGE_BILLING = `${DEVICE_PROFILE_BASE_URL}/batch_deactivate_device_usage_billing`;
const MAX_PROFILES_RESULTS = 100;
let DeviceProfileV2 = (_dec = readOnly('userInfo.token'), _dec2 = service('device-profiles-v2/cdp-events'), _dec3 = service('device-profiles-v2/gift-card-defaults-service'), _class = (_isSuccess = /*#__PURE__*/new WeakSet(), class DeviceProfileV2 extends Service {
  constructor(...args) {
    super(...args);
    /* Private */
    _classPrivateMethodInitSpec(this, _isSuccess);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "merchantToken", _descriptor2, this);
    _initializerDefineProperty(this, "cdpEventsService", _descriptor3, this);
    _initializerDefineProperty(this, "giftCardDefaultsService", _descriptor4, this);
  }
  // Here for backwards compatibility with addons expecting an ember model returned
  // on create
  async deprecatedCreateDeviceProfile(deviceProfile) {
    const proto = DeviceProfileV2Model.toProto(deviceProfile);
    const profile = await this.createDeviceProfile(proto);
    return DeviceProfileV2Model.fromProto(profile);
  }
  async getDeviceProfiles(cursor = undefined, objects = [], device, type) {
    const {
      deviceProfiles,
      nextCursor
    } = await this._fetchProfiles(cursor, device, type, undefined, MAX_PROFILES_RESULTS);
    const newObjects = [...objects, ...deviceProfiles];
    return isPresent(nextCursor) && nextCursor !== 0 ? this.getDeviceProfiles(nextCursor, newObjects, device, type) : newObjects;
  }
  getDeviceProfile(id) {
    return this._fetchProfiles(undefined, undefined, undefined, id).then(resp => {
      return resp.deviceProfiles[0];
    });
  }
  createDeviceProfile(deviceProfile) {
    const createRequest = new CreateDeviceProfileV2Request.Builder().deviceProfile(deviceProfile).build();
    const json = underscore(createRequest.toJSON());
    return jsonPost(DEVICE_PROFILE_CREATE_URL, json).then(resp => {
      const proto = CreateDeviceProfileV2Response.fromObject(camelize(resp));
      if (!_classPrivateMethodGet(this, _isSuccess, _isSuccess2).call(this, proto.status)) {
        throw new DeviceProfileMessage(`Error creating profile -- Status: ${proto.status}`, Status[proto.status]);
      }
      return proto.deviceProfile;
    }).catch(err => {
      if (err instanceof DeviceProfileError) {
        this.cdpEventsService.maybeTrackProfileFetchUnexpectedStatus({
          status: err.status
        });
        throw err;
      }
      captureException(err);
      throw new DeviceProfileError(`Error creating profile ${JSON.stringify(err)}`, err);
    });
  }
  createDefaultDeviceProfile(name, deviceProfileType, templateType, shared = true) {
    const createRequest = new CreateDefaultDeviceProfileV2Request.Builder().name(name).deviceProfileType(deviceProfileType).shared(shared).templateType(templateType).build();
    const json = underscore(createRequest.toJSON());
    return jsonPost(DEVICE_PROFILE_CREATE_DEFAULT_URL, json).then(resp => {
      const proto = CreateDefaultDeviceProfileV2Response.fromObject(camelize(resp));
      if (!_classPrivateMethodGet(this, _isSuccess, _isSuccess2).call(this, proto.status)) {
        throw new DeviceProfileMessage(`Error creating profile -- Status: ${proto.status}`, Status[proto.status]);
      }
      if ([DeviceProfileType.RESTAURANT, DeviceProfileType.RESTAURANT_MOBILE].includes(deviceProfileType)) {
        this.giftCardDefaultsService.setConfigurationDefaults();
      }
      return proto.deviceProfile;
    }).catch(err => {
      if (err instanceof DeviceProfileError) {
        this.cdpEventsService.maybeTrackProfileFetchUnexpectedStatus({
          status: err.status
        });
        throw err;
      }
      captureException(err);
      throw new DeviceProfileError(`Error creating default profile ${JSON.stringify(err)}`, err);
    });
  }
  duplicateDeviceProfile(name, targetProfileType, sourceProfileToken) {
    const duplicateRequest = new DuplicateDeviceProfileV2Request.Builder().name(name).targetProfileType(targetProfileType).deviceProfileId(sourceProfileToken).build();
    const json = underscore(duplicateRequest.toJSON());
    return jsonPost(DEVICE_PROFILE_DUPLICATE_URL, json).then(resp => {
      const proto = DuplicateDeviceProfileV2Response.fromObject(camelize(resp));
      if (!_classPrivateMethodGet(this, _isSuccess, _isSuccess2).call(this, proto.status)) {
        throw new DeviceProfileMessage(`Error duplicating profile -- Status: ${proto.status}`, Status[proto.status]);
      }
      return proto.deviceProfile;
    }).catch(err => {
      if (err instanceof DeviceProfileError) {
        this.cdpEventsService.maybeTrackProfileFetchUnexpectedStatus({
          status: err.status
        });
        throw err;
      }
      captureException(err);
      throw new DeviceProfileError(`Error duplicating profile ${JSON.stringify(err)}`, err);
    });
  }
  updateDeviceProfile(deviceProfile) {
    const updateRequest = new UpdateDeviceProfileV2Request.Builder().deviceProfile(deviceProfile).build();
    const json = underscore(updateRequest.toJSON());
    return jsonPost(DEVICE_PROFILE_UPDATE_URL, json).then(resp => {
      const proto = UpdateDeviceProfileV2Response.fromObject(camelize(resp));
      if (!_classPrivateMethodGet(this, _isSuccess, _isSuccess2).call(this, proto.status)) {
        if (proto.status === Status.OUTDATED_VERSION) {
          this.cdpEventsService.trackProfileResolutionAttempted();
        }
        throw new DeviceProfileMessage(`Unable to update profile -- Status: ${proto.status}`, Status[proto.status]);
      }
      return proto.deviceProfile;
    }).catch(err => {
      if (err instanceof DeviceProfileError) {
        this.cdpEventsService.maybeTrackProfileFetchUnexpectedStatus({
          status: err.status
        });
        throw err;
      }
      captureException(err);
      throw new DeviceProfileError(`Error updating profile ${JSON.stringify(err)}`, err);
    });
  }
  deleteDeviceProfile(deviceProfileId) {
    const deleteRequest = new DeleteDeviceProfileV2Request.Builder().deviceProfileToken(deviceProfileId).build();
    const json = underscore(deleteRequest.toJSON());
    return jsonPost(DEVICE_PROFILE_DELETE_URL, json).then(resp => {
      const proto = DeleteDeviceProfileV2Response.fromObject(camelize(resp));
      if (!_classPrivateMethodGet(this, _isSuccess, _isSuccess2).call(this, proto.status)) {
        throw new DeviceProfileMessage(`Error deleting profile -- Status: ${proto.status}`, Status[proto.status]);
      }
      return true;
    }).catch(err => {
      if (err instanceof DeviceProfileError) {
        this.cdpEventsService.maybeTrackProfileFetchUnexpectedStatus({
          status: err.status
        });
        throw err;
      }
      captureException(err);
      throw new DeviceProfileError(`Error deleting profile ${JSON.stringify(err)}`, err);
    });
  }
  async searchAllDeviceProfiles(idFilter = [], typeFilter = [], scopeFilter, nameFilter = undefined, maxResults = undefined, includeLinkedDevicesCount = false, includeTotalProfileCount = false, cursor = undefined, accProfiles = []) {
    const {
      profileResults,
      cursor: nextCursor
    } = await this.searchDeviceProfiles(idFilter, typeFilter, scopeFilter, nameFilter, maxResults, includeLinkedDevicesCount, includeTotalProfileCount, cursor);
    const newProfiles = [...accProfiles, ...profileResults];
    return nextCursor ? this.searchAllDeviceProfiles(idFilter, typeFilter, scopeFilter, nameFilter, maxResults, includeLinkedDevicesCount, includeTotalProfileCount, nextCursor, newProfiles) : newProfiles;
  }
  searchDeviceProfiles(idFilter = [], typeFilter = [], scopeFilter = undefined, nameFilter = undefined, maxResults = undefined, includeLinkedDevicesCount = false, includeTotalProfileCount = false, cursor = undefined, sortDirection = SearchDeviceProfilesV2Filter.SortDirection.ASC, enforceTypeFilterSet = false) {
    if (enforceTypeFilterSet && typeFilter.length === 0) {
      return Promise.resolve(SearchDeviceProfilesV2Response.fromObject({
        profile_results: [],
        total_profile_count: 0
      }));
    }
    const searchRequest = new SearchDeviceProfilesV2Request.Builder().query(new SearchDeviceProfilesV2Query.Builder().filter(new SearchDeviceProfilesV2Filter.Builder().idFilter(idFilter).typeFilter(typeFilter).scopeFilter(scopeFilter).nameFilter(nameFilter).sortField(SearchDeviceProfilesV2Filter.SortField.DEVICE_PROFILE_NAME).sortDirection(sortDirection).build()).build()).pagination(new Pagination.Builder().cursor(cursor).maxResults(maxResults).build()).includeLinkedDevicesCount(includeLinkedDevicesCount).includeTotalProfileCount(includeTotalProfileCount).build();
    const json = underscore(searchRequest.toJSON());
    return jsonPost(DEVICE_PROFILE_SEARCH_URL, json).then(resp => {
      return SearchDeviceProfilesV2Response.fromObject(camelize(resp));
    }).catch(err => {
      captureException(err);
      throw new DeviceProfileError(`Error searching profile ${JSON.stringify(err)}`, err);
    });
  }
  getProfileTemplates(type) {
    const getTemplatesRequest = new ListDeviceProfileV2TemplateTypesRequest.Builder().deviceProfileType(type).build();
    const json = underscore(getTemplatesRequest.toJSON());
    return jsonPost(DEVICE_PROFILE_TEMPLATES_URL, json).then(resp => {
      return ListDeviceProfileV2TemplateTypesResponse.fromObject(camelize(resp));
    }).catch(err => {
      captureException(err);
      throw new DeviceProfileError(`Error fetching profile template types ${JSON.stringify(err)}`, err);
    });
  }
  getDefaultProfile(type) {
    const getDefaultRequest = new GetDefaultDeviceProfileV2Request.Builder().deviceProfileType(type).build();
    const json = underscore(getDefaultRequest.toJSON());
    return jsonPost(DEVICE_PROFILE_GET_DEFAULT_PROFILE, json).then(resp => {
      return GetDefaultDeviceProfileV2Response.fromObject(camelize(resp));
    }).catch(err => {
      captureException(err);
      throw new DeviceProfileError(`Error fetching profile default profile ${JSON.stringify(err)}`, err);
    });
  }
  getDevicesLinkedToProfileV2(deviceProfileId, cursor = undefined, maxResults = undefined) {
    const request = new GetDevicesLinkedToProfileV2Request.Builder().deviceProfileId(deviceProfileId).pagination(new Pagination.Builder().cursor(cursor).maxResults(maxResults).build()).build();
    const json = underscore(request.toJSON());
    return jsonPost(DEVICE_PROFILE_GET_DEVICES_LINKED_TO_PROFILE, json).then(resp => {
      return GetDevicesLinkedToProfileV2Response.fromObject(camelize(resp));
    }).catch(err => {
      captureException(err);
      throw new DeviceProfileError(`Error getting devices linked to profile ${JSON.stringify(err)}`, err);
    });
  }
  _fetchProfiles(cursor, device, type, deviceProfileToken, maxResults) {
    const fetchRequest = new FetchDeviceProfileV2Request.Builder().merchantToken(this.merchantToken).deviceProfileToken(deviceProfileToken).pagination(new Pagination.Builder().cursor(cursor).maxResults(maxResults).build()).linkedDevice(device).deviceProfileType(type).build();
    const json = underscore(fetchRequest.toJSON());
    return jsonPost(DEVICE_PROFILE_FETCH_URL, json).then(resp => {
      const proto = FetchDeviceProfileV2Response.fromObject(camelize(resp));
      if (!_classPrivateMethodGet(this, _isSuccess, _isSuccess2).call(this, proto.status)) {
        this.cdpEventsService.maybeTrackProfileFetchUnexpectedStatus({
          status: Status[proto.status]
        });
        return FetchDeviceProfileV2Response.fromObject({
          profiles: [],
          nextCursor: null
        });
      }
      return proto;
    }).catch(err => {
      captureException(err);
      throw new DeviceProfileError(`Error fetching profiles ${JSON.stringify(err)}`, err);
    });
  }
  async batchDeactivateDeviceUsageBilling(applicationType, deviceId) {
    const request = new BatchDeactivateDeviceUsageBillingRequest.Builder().applicationType(applicationType).deviceId(deviceId).build();
    const json = underscore(request.toJSON());
    try {
      await jsonPost(DEVICE_PROFILE_BATCH_DEACTIVATE_DEVICE_USAGE_BILLING, json).then(resp => {
        const proto = BatchDeactivateDeviceUsageBillingResponse.fromObject(camelize(resp));
        if (!_classPrivateMethodGet(this, _isSuccess, _isSuccess2).call(this, proto.status)) {
          throw new DeviceProfileMessage(`Error deactivating device usage billing -- Status: ${proto.status}`, Status[proto.status]);
        }
        return true;
      });
    } catch (err) {
      captureException(err);
      throw new DeviceProfileError(`Error deactivating device usage billing ${JSON.stringify(err)}`, err);
    }
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "merchantToken", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cdpEventsService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "giftCardDefaultsService", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
function _isSuccess2(status) {
  return status === Status.SUCCESS;
}
export { DeviceProfileV2 as default };